export default "__VITE_ASSET__BQk0Z_20__"